import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'da';
    document.title = 'IDRÆT KLAR™ – Færdige idrætslektioner til 0.–9. klasse';
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3mk852v2dm5by">
      <div lang="da" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="3mj6j3vjtnyfg">
        <CountdownBar data-id="element-2" data-mp="3recbnd7qcbci" />
        <main data-id="element-3" data-mp="5ott78p769p">
          <Hero data-id="element-4" data-mp="67z9oh5w26u" />
          <StatsBar data-id="element-5" data-mp="4wylxj0jajy" />
          <Difference data-id="element-6" data-mp="56mnfkhz7n0" />
          <Recognize data-id="element-7" data-mp="7stte3h7l4p" />
          <WhatsInside data-id="element-8" data-mp="2zllff2q1qmn9" />
          <InsidePages data-id="element-9" data-mp="2zm4xqkjlzd1t" />
          <Bonuses data-id="element-10" data-mp="2zmwit1fkxsdu" />
          <HowItWorks data-id="element-11" data-mp="2zng2onosiqui" />
          <Audience data-id="element-12" data-mp="33m5be2yvvk7t" />
          <Offer data-id="element-13" data-mp="33nq6put0v76q" />
          <Guarantee data-id="element-14" data-mp="33n6yj5t6bx5w" />
          <Testimonials data-id="element-15" data-mp="33ork45xig5rm" />
          <Faq data-id="element-16" data-mp="38m1elzzrb7mb" />
          <FinalCta data-id="element-17" data-mp="38li8rhnds9on" />
        </main>
        <Footer data-id="element-18" data-mp="38k6x6vnp1xmz" />
      </div>
    </MotionConfig>;
}